import { render, staticRenderFns } from "./pageMain.vue?vue&type=template&id=c8f43704&scoped=true"
import script from "./pageMain.vue?vue&type=script&lang=js"
export * from "./pageMain.vue?vue&type=script&lang=js"
import style0 from "./pageMain.vue?vue&type=style&index=0&id=c8f43704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f43704",
  null
  
)

export default component.exports